export const getStopwatchTime = (startAt: number, stopAt: number): string => {
  const endTime = stopAt || Date.now()
  const timeDiff = endTime - startAt
  const seconds = timeDiff / 1000

  return seconds.toFixed(2) ?? '0.00'
}

export const getTimeDiffBetweenTimestamps = (startAt: number, stopAt: number): string => {
  const endTime = stopAt || Date.now()
  const timeDiff = endTime - startAt
  const seconds = timeDiff / 1000

  const positiveSeconds = seconds < 0 ? seconds * -1 : seconds

  return positiveSeconds.toFixed(2) ?? '0.00'
}

export const getTimeAsNumberBetween = (startAt: number, stopAt: number): number => {
  const endTime = stopAt || Date.now()
  const timeDiff = endTime - startAt
  const seconds = timeDiff / 1000

  return seconds
}
